import React, { Component } from 'react';

class BodyModal extends Component {
    constructor( props ) {
        super( props );
    }
    render() {
        const {cliente}=this.props;
        let clienteTitular =1;
        let tipoDeCliente=null;
        let FirstCondition = null;
        let FirstConditionCliente = null;
        let SecondCondition = null;
        let SecondConditionCliente = null;
        let classOcupacion = null;
        let secondClassOcupacion = null;        
        let FechaNacimiento= "";
        let EstadoCivil=cliente.estadoCivil;
        let CondicionIngresosBrutos=cliente.IIBBDescripcion; 
        let CondicionImpuestoGanancias=cliente.gananciasDescripcion; 
        let CondicionIVA= cliente.iva;
        let Sexo= cliente.DatosClientes ? (cliente.tipoCliente == "F" ? (cliente.DatosClientes.Sexo =="M" ? "Masculino":"Femenino") : "-"):"-";
        let Nacionalidad = cliente.pais ? cliente.pais : "-";
        let Ocupacion = cliente.ocupacion ? cliente.ocupacion : "-";
        let TituloCliente = cliente.tipoCliente == "F" ? "Nombre y Apellido" : "Razón Social";
        let NombreCliente = cliente.identidadCliente; 
        let NumDocumento= cliente.NUMERO_DOCUMENTO;
        let tipoDocumento = cliente.tipoCliente == "F" ? (cliente.TIPO_DOCUMENTO ? cliente.TIPO_DOCUMENTO :""):"CUIT";
        let documento = "", cuit = "", cuitPersonaFisica = "";

        if (cliente) {
            if (cliente.NumeroDocumento)
                documento = cliente.NumeroDocumento.toString();
            else if (cliente.Documento)
                documento = cliente.Documento.toString();

            cuit = documento.includes("-") ? documento : cuit + documento.substring(0, 2) + "-" + documento.substring(2, ((documento.length) - 1)) + "-" + documento[documento.length - 1]

            if (cliente.FisicaJuridica == "F" || cliente.esPersonaFisica) {
                cuitPersonaFisica = cliente.Cuit.toString();
                if (cuitPersonaFisica && cuitPersonaFisica != '')
                    cuit = cuitPersonaFisica.includes("-") ? cuitPersonaFisica : cuitPersonaFisica.substring(0, 2) + "-" + cuitPersonaFisica.substring(2, ((cuitPersonaFisica.length) - 1)) + "-" + cuitPersonaFisica[cuitPersonaFisica.length - 1];
                else
                    cuit = documento;
            }
        }

        function cortarOcupacion(ocupacion){
            let salto= "\n"
            let strNuevo=""
            for (var i =0;i<ocupacion.length;i++){
               if(i>10 && ocupacion[i]=="/"){
                strNuevo+= salto
               }if(i>10 && ocupacion[i]==" "){
                strNuevo+= salto
               }else{
                strNuevo+=ocupacion[i]
               }
            }
            return strNuevo
        }

        if(Ocupacion != "-") Ocupacion = cortarOcupacion(Ocupacion)
        
        if(cliente.DatosClientes && cliente.DatosClientes.FechaNac){
            let fechaAux=cliente.DatosClientes.FechaNac;
            FechaNacimiento += fechaAux.substring(6,8) + "/"+ fechaAux.substring(4,6) + "/" + fechaAux.substring(0,4);
        }

        
        switch ( clienteTitular) {
            case 1:
                {/* se agrega la clase con el separador, en caso de que sea cliente titular, al item de ocupacion*/ }
                classOcupacion = "right-separator separador-td-alta-individuo primary-td-modal-solicitud"
                secondClassOcupacion = "right-separator secondary-td-modal-solicitud"
                if ( cliente.tipoCliente == "F" ) {
                    {/*Si el cliente es persona fisica muestra los datos necesarios */ }
                    tipoDeCliente = ( <td className="secondary-td-modal-solicitud"><span className="ti-user"></span> Persona Física</td> )
                    FirstCondition = "Fecha Nacimiento ";
                    FirstConditionCliente = FechaNacimiento
                    SecondCondition = "Estado Civil";
                    SecondConditionCliente = EstadoCivil;
                }
                else {
                    {/*Si el cliente es persona Fiscal muestra los datos necesarios */ }
                    tipoDeCliente = ( <td className="secondary-td-modal-solicitud"><div className="iconoPersonaJuridicaDiv" style={{marginRight:"5px"}}><div className="iconoPersonaJuridicaImg" ></div></div> Persona Jurídica</td> )
                    FirstCondition = "Condición Ingresos Brutos";
                    FirstConditionCliente = CondicionIngresosBrutos;
                    SecondCondition = "Condición Impuesto a las Ganancias";
                    SecondConditionCliente = CondicionImpuestoGanancias;
                }
                break;
            case 2:
                {/* se quita la clase con el separador, en caso de que sea cliente titular, al item de ocupacion*/ }
                classOcupacion = "separador-td-alta-individuo primary-td-modal-solicitud";
                secondClassOcupacion = "secondary-td-modal-solicitud";

                tipoDeCliente = ( <td className="secondary-td-modal-solicitud"><span className="ti-user"></span> Persona Física</td> )
                FirstCondition = "Fecha Nacimiento ";
                FirstConditionCliente = FechaNacimiento
                SecondCondition = "Estado Civil";
                SecondConditionCliente = EstadoCivil;
                break;
        }

        
       
       

    return (   
        <div className="row modal-body body-alta-individuo">
            <div className="col-md-12 col-tipo-nombre-cliente">
                <div className="row">
                    <td className="primary-td-modal-solicitud">Tipo de Cliente</td>
                </div>
                <div className="row">
                    {tipoDeCliente}
                </div>
                <div className="row row-nombre">
                    <td className="primary-td-modal-solicitud">{TituloCliente}</td>
                </div>
                <div className="row">
                    <td className="secondary-td-modal-solicitud">{NombreCliente}</td>
                </div>
            </div>
            <div className="col-md-12 col-datos-individuo">
                <div className="row">
                    <div className="col-md-12">
                        
                        {cliente.tipoCliente == "F" ? <td className="right-separator separador-td-alta-individuo primary-td-modal-solicitud"> Tipo y N° de Doc. </td> : null}
                        {cliente.tipoCliente == "F" ? <td className="second-col primary-td-modal-solicitud">Cuit</td> : <td className="separador-td-alta-individuo primary-td-modal-solicitud">Cuit</td>}
                    </div>
                    <div className="col-md-12">
                        {cliente.tipoCliente == "F" ? <td className="right-separator secondary-td-modal-solicitud"> {tipoDocumento+ " - " +NumDocumento}</td> : null}
                        {cliente.tipoCliente == "F" ? <td className="second-col primary-td-modal-solicitud">{cuit}</td> : <td className="separador-td-alta-individuo primary-td-modal-solicitud">{cuit}</td>}
                    </div>
                </div>
          
                <div className="row">
                    <div className="col-md-12">
                            <td className="right-separator separador-td-alta-individuo primary-td-modal-solicitud">Sexo</td>
                            <td className="second-col primary-td-modal-solicitud">{FirstCondition}</td>
                    </div>
                    <div className="col-md-12">
                            <td className="right-separator secondary-td-modal-solicitud">{cliente.tipoCliente == "F" ? Sexo : "-"}</td>
                            <td className="second-col secondary-td-modal-solicitud">{FirstConditionCliente}</td>
                    </div>
                </div>
                
                <div className="row">
                    <div className="col-md-12">
                        <td className="right-separator separador-td-alta-individuo primary-td-modal-solicitud">Nacionalidad</td>
                        <td className="second-col primary-td-modal-solicitud">{SecondCondition}</td>
                    </div>
                    <div className="col-md-12">
                        <td className="right-separator secondary-td-modal-solicitud">{cliente.tipoCliente == "F" ? Nacionalidad : "-"}</td>
                            <td className="second-col secondary-td-modal-solicitud">{SecondConditionCliente}</td>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <td className={classOcupacion}>Ocupación</td>
                        {!this.props.cliente.Titular ? <td className="second-col primary-td-modal-solicitud">Condición ante el IVA</td>: null}
                    </div>
                    <div className="col-md-12">
                        <td className={secondClassOcupacion}><span className="conSaltoLinea">{Ocupacion}</span></td>
                        {!this.props.cliente.Titular ? <td className="second-col secondary-td-modal-solicitud">{CondicionIVA}</td>: null }
                    </div>
                   
                </div>
            </div>
            {!this.props.soloDatos && <div className="col-md-12 top-separator">
                <td className="float-left secondary-td-modal-solicitud"> ¿ Confirma que los datos son correctos ? </td>
            </div>}
        </div>
        )
    } 
}
export default BodyModal;